import type { SVGProps } from 'react'

export const AutomatedTask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      fill="url(#paint0_linear_2941_995)"
      height="35"
      rx="8"
      width="60"
      x="0.524994"
      y="45"
    />
    <path
      d="M19.525 50.5C17.8681 50.5 16.525 51.8431 16.525 53.5C16.525 55.1569 17.8681 56.5 19.525 56.5H51.525C53.1818 56.5 54.525 55.1569 54.525 53.5C54.525 51.8431 53.1818 50.5 51.525 50.5H19.525ZM9.52499 50.5C7.86814 50.5 6.52499 51.8431 6.52499 53.5C6.52499 55.1569 7.86814 56.5 9.52499 56.5C11.1818 56.5 12.525 55.1569 12.525 53.5C12.525 51.8431 11.1818 50.5 9.52499 50.5Z"
      fill="url(#paint1_linear_2941_995)"
      opacity="0.9"
    />
    <path
      d="M9.52499 59.5C7.86814 59.5 6.52499 60.8431 6.52499 62.5C6.52499 64.1569 7.86814 65.5 9.52499 65.5H51.525C53.1818 65.5 54.525 64.1569 54.525 62.5C54.525 60.8431 53.1818 59.5 51.525 59.5H9.52499Z"
      fill="url(#paint2_linear_2941_995)"
      opacity="0.9"
    />
    <path
      d="M33.525 68.5C31.8681 68.5 30.525 69.8431 30.525 71.5C30.525 73.1569 31.8681 74.5 33.525 74.5H51.525C53.1818 74.5 54.525 73.1569 54.525 71.5C54.525 69.8431 53.1818 68.5 51.525 68.5H33.525Z"
      fill="url(#paint3_linear_2941_995)"
      opacity="0.9"
    />
    <rect
      fill="url(#paint4_linear_2941_995)"
      height="35"
      rx="8"
      width="60"
      x="0.5"
    />
    <path
      d="M19.5 5.5C17.8431 5.5 16.5 6.84315 16.5 8.5C16.5 10.1569 17.8431 11.5 19.5 11.5H51.5C53.1569 11.5 54.5 10.1569 54.5 8.5C54.5 6.84315 53.1569 5.5 51.5 5.5H19.5ZM9.5 5.5C7.84315 5.5 6.5 6.84315 6.5 8.5C6.5 10.1569 7.84315 11.5 9.5 11.5C11.1569 11.5 12.5 10.1569 12.5 8.5C12.5 6.84315 11.1569 5.5 9.5 5.5Z"
      fill="url(#paint5_linear_2941_995)"
      opacity="0.9"
    />
    <path
      d="M9.5 14.5C7.84315 14.5 6.5 15.8431 6.5 17.5C6.5 19.1569 7.84315 20.5 9.5 20.5H51.5C53.1569 20.5 54.5 19.1569 54.5 17.5C54.5 15.8431 53.1569 14.5 51.5 14.5H9.5Z"
      fill="url(#paint6_linear_2941_995)"
      opacity="0.9"
    />
    <path
      d="M33.5 23.5C31.8431 23.5 30.5 24.8431 30.5 26.5C30.5 28.1569 31.8431 29.5 33.5 29.5H51.5C53.1569 29.5 54.5 28.1569 54.5 26.5C54.5 24.8431 53.1569 23.5 51.5 23.5H33.5Z"
      fill="url(#paint7_linear_2941_995)"
      opacity="0.9"
    />
    <foreignObject height="52" width="52" x="34.5" y="14.05">
      <div
        style={{
          backdropFilter: 'blur(3px)',
          clipPath: 'url(#bgblur_0_2941_995_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="6">
      <mask fill="white" id="path-9-inside-1_2941_995">
        <path d="M80.5 40.05C80.5 51.0957 71.5457 60.05 60.5 60.05C49.4543 60.05 40.5 51.0957 40.5 40.05C40.5 29.0043 49.4543 20.05 60.5 20.05C71.5457 20.05 80.5 29.0043 80.5 40.05Z" />
      </mask>
      <path
        d="M80.5 40.05C80.5 51.0957 71.5457 60.05 60.5 60.05C49.4543 60.05 40.5 51.0957 40.5 40.05C40.5 29.0043 49.4543 20.05 60.5 20.05C71.5457 20.05 80.5 29.0043 80.5 40.05Z"
        fill="url(#paint8_linear_2941_995)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint9_angular_2941_995_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-9-inside-1_2941_995)"
      >
        <g transform="matrix(2.75302e-10 0.02 -0.02 3.21075e-09 60.5 40.05)">
          <foreignObject height="2050" width="2050" x="-1025" y="-1025">
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M80.5 40.05H80C80 50.8195 71.2696 59.55 60.5 59.55V60.05V60.55C71.8218 60.55 81 51.3718 81 40.05H80.5ZM60.5 60.05V59.55C49.7304 59.55 41 50.8195 41 40.05H40.5H40C40 51.3718 49.1782 60.55 60.5 60.55V60.05ZM40.5 40.05H41C41 29.2804 49.7304 20.55 60.5 20.55V20.05V19.55C49.1782 19.55 40 28.7282 40 40.05H40.5ZM60.5 20.05V20.55C71.2696 20.55 80 29.2804 80 40.05H80.5H81C81 28.7282 71.8218 19.55 60.5 19.55V20.05Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:5.5060411341401050e-07,&#34;m01&#34;:-40.000007629394531,&#34;m02&#34;:80.50,&#34;m10&#34;:40.000003814697266,&#34;m11&#34;:6.4215087149932515e-06,&#34;m12&#34;:20.049982070922852},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-9-inside-1_2941_995)"
      />
    </g>
    <path
      d="M59.75 42.55V50.35C59.75 50.75 59.9417 51 60.325 51.1C60.7083 51.2 60.9833 51.0667 61.15 50.7L66.95 38.65C67.0833 38.3833 67.075 38.1333 66.925 37.9C66.775 37.6667 66.5667 37.55 66.3 37.55H61.55V29.65C61.55 29.25 61.3583 29 60.975 28.9C60.5917 28.8 60.3167 28.9333 60.15 29.3L54 41.45C53.8667 41.7167 53.875 41.9667 54.025 42.2C54.175 42.4333 54.3833 42.55 54.65 42.55H59.75Z"
      fill="url(#paint10_linear_2941_995)"
    />
    <path
      d="M34.9448 42.8125L31.3696 48.5281C31.1628 48.8427 30.8732 49 30.5008 49C30.1283 49 29.8382 48.8427 29.6304 48.5281L26.0552 42.8125C25.8476 42.4683 25.8386 42.1207 26.0283 41.7696C26.2182 41.4185 26.517 41.2429 26.9248 41.2429H29.4792V34.9801H31.5208V41.2429H34.0752C34.483 41.2429 34.7818 41.4185 34.9717 41.7696C35.1614 42.1207 35.1524 42.4683 34.9448 42.8125Z"
      fill="url(#paint11_linear_2941_995)"
    />
    <defs>
      <clipPath
        id="bgblur_0_2941_995_clip_path"
        transform="translate(-34.5 -14.05)"
      >
        <path d="M80.5 40.05C80.5 51.0957 71.5457 60.05 60.5 60.05C49.4543 60.05 40.5 51.0957 40.5 40.05C40.5 29.0043 49.4543 20.05 60.5 20.05C71.5457 20.05 80.5 29.0043 80.5 40.05Z" />
      </clipPath>
      <clipPath id="paint9_angular_2941_995_clip_path">
        <path
          d="M80.5 40.05H80C80 50.8195 71.2696 59.55 60.5 59.55V60.05V60.55C71.8218 60.55 81 51.3718 81 40.05H80.5ZM60.5 60.05V59.55C49.7304 59.55 41 50.8195 41 40.05H40.5H40C40 51.3718 49.1782 60.55 60.5 60.55V60.05ZM40.5 40.05H41C41 29.2804 49.7304 20.55 60.5 20.55V20.05V19.55C49.1782 19.55 40 28.7282 40 40.05H40.5ZM60.5 20.05V20.55C71.2696 20.55 80 29.2804 80 40.05H80.5H81C81 28.7282 71.8218 19.55 60.5 19.55V20.05Z"
          mask="url(#path-9-inside-1_2941_995)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2941_995"
        x1="30.525"
        x2="30.525"
        y1="45"
        y2="80"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2941_995"
        x1="0.540662"
        x2="54.5634"
        y1="53.5"
        y2="53.5"
      >
        <stop offset="0.197112" stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2941_995"
        x1="0.540662"
        x2="54.5634"
        y1="62.5"
        y2="62.5"
      >
        <stop offset="0.197112" stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2941_995"
        x1="27.5328"
        x2="54.5442"
        y1="71.5"
        y2="71.5"
      >
        <stop offset="0.197112" stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2941_995"
        x1="30.5"
        x2="30.5"
        y1="-2.08616e-05"
        y2="35"
      >
        <stop stopColor="#D5E3FF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_2941_995"
        x1="0.515668"
        x2="54.5384"
        y1="8.49998"
        y2="8.49998"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_2941_995"
        x1="0.515668"
        x2="54.5384"
        y1="17.5"
        y2="17.5"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_2941_995"
        x1="27.5078"
        x2="54.5192"
        y1="26.5"
        y2="26.5"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_2941_995"
        x1="60.5"
        x2="60.5"
        y1="20.05"
        y2="60.05"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_2941_995"
        x1="60.475"
        x2="53.6727"
        y1="28.8679"
        y2="48.8121"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint11_linear_2941_995"
        x1="30.5"
        x2="30.5"
        y1="49"
        y2="34.9801"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
    </defs>
  </svg>
)
